import React from "react";

export const Warning = ({ color }) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <g clipPath="url(#clip0_6363_13352)">
      <path
        d="M9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75Z"
        stroke={color}
        strokeWidth="1.125"
        strokeMiterlimit="10"
      />
      <path
        d="M9 9.5625V5.625"
        stroke={color}
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 12.9375C9.46599 12.9375 9.84375 12.5597 9.84375 12.0938C9.84375 11.6278 9.46599 11.25 9 11.25C8.53401 11.25 8.15625 11.6278 8.15625 12.0938C8.15625 12.5597 8.53401 12.9375 9 12.9375Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_6363_13352">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Success = ({ color }) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <g clipPath="url(#clip0_6532_14146)">
      <path
        d="M6.1875 9.5625L7.875 11.25L11.8125 7.3125"
        stroke={color}
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75Z"
        stroke={color}
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6532_14146">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Error = ({ color }) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <g clipPath="url(#clip0_6532_14173)">
      <path
        d="M10.0127 2.82797L16.1622 13.5063C16.5932 14.2587 16.0363 15.1875 15.149 15.1875H2.84993C1.96259 15.1875 1.40571 14.2587 1.83673 13.5063L7.98626 2.82797C8.42923 2.05734 9.56969 2.05734 10.0127 2.82797Z"
        stroke={color}
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 10.125V7.3125"
        stroke={color}
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 13.5C9.46599 13.5 9.84375 13.1222 9.84375 12.6562C9.84375 12.1903 9.46599 11.8125 9 11.8125C8.53401 11.8125 8.15625 12.1903 8.15625 12.6562C8.15625 13.1222 8.53401 13.5 9 13.5Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_6532_14173">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
